import script from "./TransferProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferProgress.vue?vue&type=script&setup=true&lang=ts"

import "./TransferProgress.vue?vue&type=style&index=0&id=2e5aef43&scoped=true&lang=less"
script.__scopeId = "data-v-2e5aef43"

export default script